<template>
  <div class="container py-14">
    <PublicBanner text="کاربرد گواهینامه معادل" />
    <PublicList :index_items="usage" text_icon="mdi-check-outline" />
  </div>
</template>

<script>
import PublicBanner from "@/packages/public/components/PublicBanner";
import PublicList from "@/packages/public/components/PublicList";
export default {
  name: "Application",
  components: { PublicList, PublicBanner },
  data() {
    return {
      usage: [
        { text: "ثبت شرکت در برخی موارد" },
        { text: "مهاجرت به برخی کشور ها" },
        { text: "اخذ پروانه کسب از برخی اتحادیه ها" },
        { text: "استخدام در شرکتها و کارخانه جات خصوصی" },
        { text: "افزایش حقوق وارتقا شغلی در برخی ادارات و مراکزخصوصی" },
        { text: "بالا بردن وجهه اجتماعی وپر کردن رزومه کاری" },
        { text: "ایجاد اشتغال و راه اندازی" },
      ],
    };
  },
};
</script>

<style scoped>
h3 {
  margin-bottom: 1rem;
  font-size: 20px;
}
p {
  font-weight: bold;
  font-size: 18px;
}
</style>
